import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import {
  CommonModalFooter,
  CommonModalHeader,
  ModalDialog,
} from "../../../modal";

import "./RemoveDeviceDialog.scss";

class RemoveDeviceDialog extends Component {
  render() {
    const { modal, deviceName } = this.props;

    return (
      <ModalDialog
        className={"remove-device-modal"}
        submitHandler={this.onSubmit}
        rejectHandler={() => modal.reject()}
      >
        <CommonModalHeader>
          <FormattedMessage id={"remove_device"} />
        </CommonModalHeader>
        <ModalDialog.Body>
          <div className={"remove-device-modal__message"}>
            <FormattedMessage
              id={"remove_device_description"}
              values={{
                device: <span className={"text-emphasized"}>{deviceName}</span>,
              }}
            />
          </div>
          <div className={"remove-device-modal__note"}>
            <FormattedMessage id={"remove_device_note"} />
          </div>
        </ModalDialog.Body>
        <CommonModalFooter
          submitMessage={<FormattedMessage id="remove" />}
          submitButtonType="destructive"
          autoFocus
        />
      </ModalDialog>
    );
  }

  onSubmit = () => this.props.modal.resolve(this.props.deviceName);
}

RemoveDeviceDialog.propTypes = {
  deviceName: PropTypes.string,
};

export default RemoveDeviceDialog;
